module.exports = __webpack_public_path__ + "static/media/bali.dd955e25.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sound/bali.mp3
// module id = 141
// module chunks = 0